import { useCallback } from 'react';
import { isNil } from 'lodash';

import { useChatController } from '~/components/AiChat/controller/ChatControllerContext';
import mixpanel from '~/components/CmsMain/mixpanel';

import { useChatSource } from '../contexts/ChatSourceContext';

import { useChatContext } from './useChat';

export const useChatMixpanel = () => {
  const analytics = useChatController()?.analytics;
  const contextSource = useChatSource();
  const { chat } = useChatContext();

  // Inside a chat the controller says which conversation an event belongs to; elsewhere on a claim
  // page (the chat's header, its history) it is the claim chat's.
  const source = analytics ? analytics.source : contextSource;
  const chatId = analytics ? analytics.conversationId : (chat?.internal_id ?? null);
  const agentKey = analytics?.agentKey;

  const trackChatEvent = useCallback(
    (eventName: string, properties: Record<string, unknown> = {}) => {
      mixpanel.track(eventName, {
        source,
        chat_id: chatId,
        ...(isNil(agentKey) ? {} : { agent_key: agentKey }),
        ...properties,
      });
    },
    [source, chatId, agentKey]
  );

  return { trackChatEvent };
};
